import type { PaymentTier } from "@/shared/utils/tierOrder";

interface TierConfig {
  tier: PaymentTier;
  name: string;
  subtitle: string;
  price: string;
  features: string[];
  buttonLabel: string;
  includesPrefix?: string;
  upgradeFromBasicPrice: string;
  upgradeFromPremiumPrice?: string;
}

export const TIER_CONFIGS: Record<"basic" | "premium" | "platinum", TierConfig> = {
  basic: {
    tier: "basic",
    name: "Estate Setup",
    subtitle: "Best for early on, when you need to organize and file",
    price: "$500",
    features: [
      "A personalized roadmap with your next steps and key deadlines",
      "An estimated inventory of the estate, so you see the full picture early",
      "Probate forms, you can review and file when you\u2019re ready",
    ],
    buttonLabel: "Start setup",
    upgradeFromBasicPrice: "$0",
  },
  premium: {
    tier: "premium",
    name: "Asset Search",
    subtitle: "Best for finding accounts and debts you didn\u2019t know existed",
    price: "$3,000",
    features: [
      "Elayne Asset Search across 100+ sources, including government records",
      "Debts, insurance, property, and records others miss, found for you",
      "A 1:1 session with your Estate Expert to review the results",
    ],
    buttonLabel: "Find assets",
    includesPrefix: "Everything in Estate Setup, plus",
    upgradeFromBasicPrice: "$2,500",
  },
  platinum: {
    tier: "platinum",
    name: "Estate Settlement",
    subtitle: "Best for managing the estate bank account and final steps",
    price: "$6,000",
    features: [
      "Banks and institutions contacted for you",
      "EIN application submitted and transfer forms pre-filled",
      "Track the estate bank account, with 1:1 Estate Expert sessions for questions",
    ],
    buttonLabel: "Start closing",
    includesPrefix: "Everything in Asset Search, plus",
    upgradeFromBasicPrice: "$5,500",
    upgradeFromPremiumPrice: "$3,000",
  },
} as const;

export const PLAN_NAME_BY_TIER: Record<PaymentTier, string> = {
  free: TIER_CONFIGS.basic.name,
  basic: TIER_CONFIGS.basic.name,
  premium: TIER_CONFIGS.premium.name,
  platinum: TIER_CONFIGS.platinum.name,
};

export const BASIC_CARD_FEATURES = TIER_CONFIGS.basic.features;

export const PREMIUM_CARD_FEATURES = TIER_CONFIGS.premium.features;

export const PREMIUM_BADGE = "$5M+ found with Elayne Asset Search";

export const PLATINUM_CARD_FEATURES = TIER_CONFIGS.platinum.features;
